import { Reveal } from "@/components/primitives";

export default function PageHeader({ index, eyebrow, title, sub }) {
  return (
    <section className="grain relative bg-ink px-6 pb-16 pt-28 lg:px-12 lg:pb-20 lg:pt-36" data-testid="page-header">
      <div className="relative z-10 mx-auto max-w-[1440px]">
        <Reveal>
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-paper/60">
            <span style={{ color: "#C8554F" }}>{index}</span> · {eyebrow}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 font-serif text-4xl leading-tight text-paper sm:text-6xl">{title}</h1>
        </Reveal>
        {sub && (
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl text-sm leading-relaxed text-paper/70">{sub}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
